// extracted by mini-css-extract-plugin
export default {"root":"LMKzDH","title":"rooxg6","subtitle":"ED1bm_"};